import { Capacitor } from "@capacitor/core";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

const STALE_ASSETS_RELOAD_KEY = "izumrud-stale-assets-reload-at";
const STALE_ASSETS_RELOAD_WINDOW_MS = 15_000;

function getErrorMessage(value: unknown) {
  if (value instanceof Error) {
    return value.message;
  }

  return typeof value === "string" ? value : "";
}

function isStaleChunkError(message: string) {
  const normalized = message.toLowerCase();

  return (
    normalized.includes("failed to fetch dynamically imported module") ||
    normalized.includes("importing a module script failed") ||
    normalized.includes("unable to preload css")
  );
}

function reloadForStaleAssets() {
  const lastReloadAt = Number(window.sessionStorage.getItem(STALE_ASSETS_RELOAD_KEY) ?? "0");
  const now = Date.now();

  if (now - lastReloadAt < STALE_ASSETS_RELOAD_WINDOW_MS) {
    return false;
  }

  window.sessionStorage.setItem(STALE_ASSETS_RELOAD_KEY, String(now));
  window.location.reload();
  return true;
}

window.addEventListener("vite:preloadError", (event) => {
  const preloadEvent = event as Event & {
    payload?: unknown;
    preventDefault: () => void;
  };
  const message = getErrorMessage(preloadEvent.payload);

  if (!isStaleChunkError(message)) {
    return;
  }

  preloadEvent.preventDefault();
  reloadForStaleAssets();
});

window.addEventListener("unhandledrejection", (event) => {
  const message = getErrorMessage(event.reason);

  if (!isStaleChunkError(message)) {
    return;
  }

  event.preventDefault();
  reloadForStaleAssets();
});

if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add("native-app");
  document.body.classList.add("native-app");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
